import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "gatsby-theme-style-guide"
    }}>{`gatsby-theme-style-guide`}</h1>
    <p>{`Automatically generate a style guide page based on your Theme UI configuration, built with `}<a parentName="p" {...{
        "href": "https://theme-ui.com/packages/style-guide"
      }}><inlineCode parentName="a">{`@theme-ui/style-guide`}</inlineCode></a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i gatsby-theme-style-guide
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: ['gatsby-plugin-theme-ui', 'gatsby-theme-style-guide'],
}
`}</code></pre>
    <p>{`This theme will create a page at `}<inlineCode parentName="p">{`/style-guide`}</inlineCode>{` that includes typographic styles and colors based on your theme.`}</p>
    <h2 {...{
      "id": "options"
    }}>{`Options`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`module.exports = {
  plugins: [
    'gatsby-plugin-theme-ui',
    {
      resolve: 'gatsby-theme-style-guide',
      options: {
        // sets path for generated page
        basePath: '/design-system',
      },
    },
  ],
}
`}</code></pre>
    <h2 {...{
      "id": "shadowing"
    }}>{`Shadowing`}</h2>
    <p>{`You can customize the layout and order of the page by `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/themes/shadowing/"
      }}>{`shadowing`}</a>{` the theme.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/template.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the root component for the page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/layout.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`wrapper for adding a page layout`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/header.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`header for the top of the page`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/typography.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`section for typography styles`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`src/colors.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`section for colors`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`For example, to shadow the `}<inlineCode parentName="p">{`template.js`}</inlineCode>{` file, you would create a file named `}<inlineCode parentName="p">{`your-site/src/gatsby-theme-style-guide/template.js`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      